import LegalPrivacy from './legalPrivacy'

export default LegalPrivacy